import React from 'react';

import GlobalContext from '../contexts/GlobalContext';

const useNotify = () => {
	const { updateNotifications } = React.useContext(GlobalContext);

	return React.useCallback(
		(notify: Partial<ToastNotification>) =>
			updateNotifications((currentNotifications) => {
				return [
					...currentNotifications,
					{
						id: new Date().getTime(),
						title: '',
						message: '',
						type: 'success',
						...notify,
					},
				];
			}),
		[updateNotifications]
	);
};

export default useNotify;
